<template>
  <NsSelect
    v-model="model"
    class="df-select"
    :label="schema.label"
    :hint="schema.hint"
    :items="schema.items"
    :item-text="schema.itemText"
    :item-value="schema.itemValue"
    :rules="rules"
    menu-props="{ auto: true }"
    type="text"
  />
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import NsSelect from '../../NsSelect.vue';

import { PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'NsInputSelectField',
  components: {
    NsSelect,
  },
  mixins: [PropsMixin, RulesMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {string}
     */
    value: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/_typographyVariables.scss" as types;
::v-deep {
  font-family: map.get(types.$typography, 'font-family-primary');
  .v-label {
    font-family: map.get(types.$typography, 'font-family-primary');
    line-height: 22px;
    transform: none !important;
    animation: none !important;
  }
  .v-select__slot {
    align-items: stretch !important;
  }
}
</style>
